<template>
  <div>
    <div v-for="(item, index) in value" :key="index">
      <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }">
        <pn-input-container :label="label">
          <input :id="name + index" v-model="value[index].value" />
        </pn-input-container>
        <div class="validation-text">{{ $t(errors[0]) }}</div>
      </ValidationProvider>
    </div>
    <button
      class="add-button"
      v-show="!maxAmount"
      type="button"
      @click="addField()"
    >
      {{ addLabel }}
    </button>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
let id = 0
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false
    },
    max: {
      type: String,
      required: false
    },
    rules: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false,
      default: 'multiTextField'
    },
    addLabel: {
      type: String,
      required: false,
      default: 'Add field'
    }
  },
  computed: {
    maxAmount() {
      if (!this.max) {
        return false
      }
      return this.value.length >= this.max
    }
  },
  components: {
    ValidationProvider
  },
  methods: {
    addField() {
      if (!this.maxAmount) {
        this.value.push({
          id: id,
          value: ''
        })

        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
pn-input-container {
  width: 100%;
  margin-top: 1em;
}
.validation-text {
  margin-top: 0.5em;
  font-size: 0.875em;
  color: $warning;
}

.add-button {
  margin-top: 1em;
  border: none;
  font-size: 0.9em;
  color: $blue700;
  background-color: unset;

  &:active {
    outline: none;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
